import styled from 'styled-components';

export const DefaultImage = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 1px solid #dfe0eb;
  background-color: #eef1f6;
  cursor: pointer;
`;

export const ImageContainer = styled.figure`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 1px solid #dfe0eb;
  overflow: hidden;
  cursor: pointer;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;
